// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2F7v_","gfeWrapper":"CalendarEvent_gfeWrapper__1l0II"};